import { Injectable } from '@angular/core';

export type SoundTypes = 'horse' | 'ring';


@Injectable({ providedIn: 'root' })
export class AudioService {
  play!: () => void;

  playSound(type: SoundTypes) {
    this.play();
  }
}
